import React from 'react';
import PropTypes from 'prop-types';

function SubmitButton({ btnText = 'Continue', disabled = false, isLoading = false }) {
  return (
    <button
      type="submit"
      disabled={disabled || isLoading}
      className="btn-primary w-full min-h-[52px] mt-6 text-base font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isLoading ? 'Please wait…' : btnText}
    </button>
  );
}

SubmitButton.propTypes = {
  btnText: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default SubmitButton;
